import React, { memo } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { getItemFromLocalStorage } from 'utils/common';
import OnboardingContainer from 'containers/OnboardingContainer/Loadable';
import { useAuth } from '../../hooks/useAuth';

import { basename } from '../../store';

const AuthPage = props => {
  const [searchParams] = useSearchParams();
  const env = searchParams.get('env') || 'prod';
  const { userObj } = useAuth();

  const action = searchParams.get('action');

  if (action && action === 'newAccount') {
    localStorage.clear();
    return <OnboardingContainer {...props} />;
  }

  const userFlow = getItemFromLocalStorage('userFlow');
  if (
    !!userObj &&
    !!userObj.cfToken &&
    !!userObj.cfToken[env] &&
    !!userObj.cfToken[env].token &&
    !!userFlow &&
    !['signup', 'login'].includes(userFlow)
  ) {
    return <Navigate to={`${basename}${userFlow}`} />;
  }
  return <OnboardingContainer {...props} />;
};

export default memo(AuthPage);
